import type { ReactNode } from 'react'

type RelatedSectionProps = {
  /** 見出し（例: そのほかのお役立ち資料） */
  title: string
  /** カード（CaseCard など li を返すもの）を並べる */
  children: ReactNode
  /**
   * PC での列数。2 はカードが 2 件のページ（セミナー）用で、
   * 3 列と同じカード幅のまま中央に寄せる
   */
  columns?: 2 | 3
}

const columnClasses: Record<
  NonNullable<RelatedSectionProps['columns']>,
  string
> = {
  3: 'lg:grid-cols-3',
  // 6 列グリッドの 2〜5 列目に置くと、3 列時と同じ幅のカードがちょうど中央に並ぶ
  2: 'lg:grid-cols-6 lg:*:col-span-2 lg:*:first:col-start-2'
}

/**
 * 詳細ページ下部の関連コンテンツ。Figma: section/related。
 * 見出し＋カード 3 列（または中央寄せの 2 列）。資料・導入事例・セミナー・コラムの詳細ページで共通。
 */
export function RelatedSection({
  title,
  children,
  columns = 3
}: RelatedSectionProps) {
  return (
    <section className="bg-surface-subtle px-6 py-12 lg:px-panelx lg:py-20">
      <div className="mx-auto flex max-w-wide flex-col items-center gap-8 lg:gap-12">
        <h2 className="fontfeaturesettings text-center text-2xl font-bold leading-heading tracking-heading text-ink lg:text-h1">
          {title}
        </h2>
        <ul
          className={`grid w-full grid-cols-1 gap-10 md:grid-cols-2 ${columnClasses[columns]}`}
        >
          {children}
        </ul>
      </div>
    </section>
  )
}
